export function FeatureFlagControl(props: {
    flag: boolean,
    activeFeature: JSX.Element,
    fallbackFeature: JSX.Element
}): JSX.Element {
    return props.flag
        ? props.activeFeature ?? null
        : props.fallbackFeature ?? null;
}
